<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @add="chooseTcOrderVisible = true"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <ChooseTcOrderDialog
      :visible.sync="chooseTcOrderVisible"
      :title="'选择TC订单'"
      @confirm="onChooseTcOrderConfirm"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import ChooseTcOrderDialog from '../choose-tc-order'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, ChooseTcOrderDialog },
  data() {
    return { usePage: true, chooseTcOrderVisible: false }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .tcFabricPurchaseListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    onChooseTcOrderConfirm({ tcOrderCode }) {
      if (!tcOrderCode) return
      this.openEditPage({ pageType: 'add', query: { tcOrderCode } })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'tc-fabricOrder-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
